import React from "react";
import "./CancelButton.css";

const CancelButton = ({ children = "Cancelar", className = "", ...props }) => {
  return (
    <button
      type="button"
      className={`cancel-button ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
};

export default CancelButton;
